import { useQuery } from 'react-query';

import { GetSubsetOverviewResponseDto } from '../../../../backend/src/case/subset/dto/get-subset-overview.response.dto';
import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

const PROCESSING_POLL_INTERVAL = 3000;

export const useGetSubsetOverview = (
  matterId?: string,
  subsetId?: string,
  options?: { isProcessing?: boolean },
) => {
  const { fetchConfigGET } = useGetFetchConfig();

  const getSubsetOverview = async (): Promise<GetSubsetOverviewResponseDto> => {
    const response = await fetch(
      `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/overview`,
      fetchConfigGET,
    );
    if (!response.ok) {
      throw new Error('Fetching subset overview failed');
    }

    return response.json();
  };

  return useQuery([QueryEntity.SubsetOverview, matterId, subsetId], getSubsetOverview, {
    enabled: !!matterId && !!subsetId,
    refetchOnWindowFocus: false,
    refetchInterval: options?.isProcessing ? PROCESSING_POLL_INTERVAL : false,
  });
};
